// components/SHSidebar/SettingsSidebar.js
import React, { useContext, useEffect, useState } from 'react';
import { FiSettings } from 'react-icons/fi';
import { TbArrowLeft } from 'react-icons/tb';
import { useLanguage } from '../../../../LanguageProvider';
import { GeneralContext } from '../../../../GeneralProvider';
import AlertBox from '../../../../components/AlertBox/AlertBox';

export default function SettingsSidebar({ selectedChannel, onMenuChange, activeMenu, handleChannelChange }) {
    const { handleDeleteChannel, handleLeaveChannel, myChannels, userId } = useContext(GeneralContext);
    const { getTranslation } = useLanguage();
    const [isAdmin, setIsAdmin] = useState("0");
    const [isOwner, setIsOwner] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);

    useEffect(() => {
        const found = myChannels.find(x => x.channelID === selectedChannel.channelID);
        if (found) {
            setIsAdmin(found.isAdmin);
            if (found.ownerID === userId) setIsOwner(true);
        }
    }, [selectedChannel, myChannels, userId]);

    const sidebarMenu = [
        { key: 'authorizations', label: getTranslation("authorizations") },
        { key: 'channelSettings', label: getTranslation("channelSettings") },
        { key: 'roomGroups', label: getTranslation("rooms") }
    ];

    const handleConfirmDelete = () => {
        handleDeleteChannel(selectedChannel.channelID);
        setIsAlertOpen(false);
        handleChannelChange();
    };

    return (
        <div className="sh-settings-sidebar">
            <div className="sh-settings-sidebar-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                {/* 🠔 Geri Butonu */}
                <button
                    onClick={() => handleChannelChange(selectedChannel, false)} 
                    className="sh-settings-back-btn"
                    style={{
                        background: 'none',
                        border: 'none',
                        color: 'var(--text)',
                        cursor: 'var(--pointer)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        fontSize: '14px'
                    }}
                >
                    <TbArrowLeft size={18} /> 
                </button>

                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span>{getTranslation("settings")}</span>
                    <FiSettings />
                </div>
            </div>

            {isAdmin === "1" && (
                <nav className="sh-settings-sidebar-menu">
                    {sidebarMenu.map(item => (
                        <div
                            key={item.key}
                            className={`sh-settings-sidebar-item ${activeMenu === item.key ? 'active' : ''}`}
                            onClick={() => onMenuChange(item.key)}
                        >
                            {item.label}
                        </div>
                    ))}
                </nav>
            )}

            {isOwner ? (
                <div style={{ width: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex', marginBottom: '15px' }}>
                    <div onClick={() => setIsAlertOpen(true)} style={{ marginTop: 'auto', alignItems: 'center', justifyContent: 'center', display: 'flex', width: '80%', borderRadius: '4px' }} className="collaborators-table-reject-button">
                        {getTranslation("deleteChannel")}
                    </div>
                </div>
            ) : (
                <div style={{ width: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex', marginBottom: '15px', marginTop: 'auto' }}>
                    <div onClick={() => { handleLeaveChannel(selectedChannel.channelID); handleChannelChange(); }} style={{ marginTop: 'auto', alignItems: 'center', justifyContent: 'center', display: 'flex', width: '80%', borderRadius: '4px' }} className="collaborators-table-reject-button">
                        {getTranslation("leaveChannel")}
                    </div>
                </div>
            )}

            <AlertBox
                isOpen={isAlertOpen}
                title={getTranslation("areYouSure")}
                message={getTranslation("deleteChannelConfirmation")}
                onConfirm={handleConfirmDelete}
                onCancel={() => setIsAlertOpen(false)}
                confirmText={getTranslation("yes")}
                cancelText={getTranslation("no")}
                type={"warning"}
            />
        </div>
    );
}
